import { CurrencyEnum } from '@systemeio/ui'
import { AffiliateChartColorsEnum } from 'modules/affiliate-program/affiliate/enums/affiliate-chart-colors-enum'
import { CSSProperties } from 'react'

export const getAffiliateChartColor = (
  currency: CurrencyEnum,
  allCurrencies: CurrencyEnum[],
): AffiliateChartColorsEnum => {
  const currencyColors = Object.values(AffiliateChartColorsEnum)
  allCurrencies.forEach(cur => {
    switch (cur) {
      case CurrencyEnum.EURO: {
        currencyColors.splice(currencyColors.indexOf(AffiliateChartColorsEnum.currency_blue), 1)
        break
      }
      case CurrencyEnum.US_DOLLAR: {
        currencyColors.splice(currencyColors.indexOf(AffiliateChartColorsEnum.currency_green), 1)
        break
      }
      case CurrencyEnum.BRAZILIAN_REAL: {
        currencyColors.splice(currencyColors.indexOf(AffiliateChartColorsEnum.currency_red), 1)
        break
      }
    }
  })
  switch (currency) {
    case CurrencyEnum.EURO: {
      return AffiliateChartColorsEnum.currency_blue
    }
    case CurrencyEnum.US_DOLLAR: {
      return AffiliateChartColorsEnum.currency_green
    }
    case CurrencyEnum.BRAZILIAN_REAL: {
      return AffiliateChartColorsEnum.currency_red
    }
    default: {
      const currencyIndex = allCurrencies.indexOf(currency)
      const colorIndex = Math.floor(Number(`0.${currencyIndex}`) * currencyColors.length)
      return currencyColors[colorIndex]
    }
  }
}

export const getAffiliateChartTextColor = (
  currency: CurrencyEnum,
  allCurrencies: CurrencyEnum[],
): CSSProperties => {
  switch (getAffiliateChartColor(currency, allCurrencies)) {
    case AffiliateChartColorsEnum.currency_blue: {
      return { color: AffiliateChartColorsEnum.currency_blue }
    }
    case AffiliateChartColorsEnum.currency_green: {
      return { color: AffiliateChartColorsEnum.currency_green }
    }
    case AffiliateChartColorsEnum.currency_red: {
      return { color: AffiliateChartColorsEnum.currency_red }
    }
    case AffiliateChartColorsEnum.currency_yellow: {
      return { color: AffiliateChartColorsEnum.currency_yellow }
    }
  }
}
